export default function PageGridItem() {
  // This component is not supposed to be rendered
  return null;
}
